import { ResponseContainer } from './DisplayContainer';
import {
  Box,
  Checkbox,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const LikertDisplay = ({ value, question }) => {
  const { t } = useTranslation();
  const theme = useTheme()

  return (
    <ResponseContainer>
      <Box sx={{ width: '100%', overflowX: 'auto' }}>
        <Table
          sx={{
            borderCollapse: 'separate',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '200px',
                  position: 'sticky',
                  left: 0,
                  borderRight: '1px solid rgba(224, 224, 224, 1);',
                  zIndex: 2,
                }}
              ></TableCell>
              {question?.answerOptions?.map((i, idx) => (
                <TableCell key={idx} align="center">
                  <Typography marginLeft={'9px'} variant="h5">
                    {i?.coding?.display}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {!question?.allowMultipleResponses
              ? question?.questions?.map((q, qIdx) => (
                <RadioGroup
                  key={qIdx}
                  style={{ display: 'table-row' }}
                  defaultValue={
                    value?.find((ans) => {
                      return ans?.question?.id === q?.id;
                    })?.answer?.id
                  }
                  sx={{
                    verticalAlign: 'middle',
                    '&:last-child td': { borderBottom: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      minWidth: '200px',
                      position: 'sticky',
                      left: 0,
                      borderRight: '1px solid rgba(224, 224, 224, 1);',
                      zIndex: 2,
                    }}
                  >
                    <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <Typography variant="h5">{`${qIdx + 1}.`}</Typography>
                      <Typography>{q.text}</Typography>
                      <Typography
                        ml={'auto'}
                        fontSize={13}
                        color={theme.palette.colors.gray400}
                      >
                        {value?.find((ans) => {
                          return ans?.question?.id === q?.id;
                        })?.score
                          ? `${t('Score')}: ${value?.find((ans) => {
                            return ans?.question?.id === q?.id;
                          })?.score
                          }`
                          : ''}
                      </Typography>
                    </Box>
                  </TableCell>

                  {question?.answerOptions?.map((a, aIdx) => (
                    <TableCell key={aIdx} align="center">
                      <Radio value={a.id} disabled />
                    </TableCell>
                  ))}
                </RadioGroup>
              ))
              : question?.questions?.map((q, qIdx) => (
                <Box
                  key={qIdx}
                  style={{ display: 'table-row' }}
                  sx={{
                    verticalAlign: 'middle',
                    '&:last-child td': { borderBottom: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      minWidth: '200px',
                      position: 'sticky',
                      left: 0,
                      borderRight: '1px solid rgba(224, 224, 224, 1);',
                      zIndex: 2,
                    }}
                  >
                    <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                      <Typography variant="h5">{`${qIdx + 1}.`}</Typography>
                      <Typography>{q.text}</Typography>
                    </Box>
                  </TableCell>

                  {question?.answerOptions?.map((a, aIdx) => (
                    <TableCell key={aIdx} align="center">
                      <Checkbox
                        checked={
                          !!value?.find(
                            (ans) =>
                              ans?.question?.id === q?.id &&
                              ans?.answer?.id === a?.id
                          )
                        }
                        disabled
                      />
                    </TableCell>
                  ))}
                </Box>
              ))}
          </TableBody>
        </Table>
      </Box>
    </ResponseContainer>
  );
};

export default LikertDisplay;
